import {
  GET_PAYMENT_TYPES,
  GET_RECHARGE_PAYMENT_METHODS,
  GET_CARD_TYPES,
  GET_RECURRING_PAYMENT_SUBSCRIPTION,
  GET_BUNDLE_GIFTING_PAYMENT_TYPES,
  GET_PAY_OTHERS_BILLS_PAYMENT_TYPES,
} from './actionsTypes'

const initialState = {
  paymentTypes: {},
  rechargePaymentMethods: {
    self: [],
    other: [],
    isLoading: true,
    error: null,
  },
  cardTypes: [],
  recurringPaymentSubscription: {},
  bundlePaymentTypes: {},
  payOthersBillsPaymentTypes: {},
}

const paymentData = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PAYMENT_TYPES:
      return {
        ...state,
        paymentTypes: payload,
      }
    case GET_RECHARGE_PAYMENT_METHODS:
      return {
        ...state,
        rechargePaymentMethods: payload,
      }
    case GET_CARD_TYPES:
      return {
        ...state,
        cardTypes: payload,
      }
    case GET_RECURRING_PAYMENT_SUBSCRIPTION:
      return {
        ...state,
        recurringPaymentSubscription: payload,
      }
    case GET_BUNDLE_GIFTING_PAYMENT_TYPES:
      return {
        ...state,
        bundlePaymentTypes: payload,
      }

    case GET_PAY_OTHERS_BILLS_PAYMENT_TYPES:
      return {
        ...state,
        payOthersBillsPaymentTypes: payload,
      }
    default:
      return state
  }
}

export default paymentData
